export const enum InputIconPosition {
  RIGHT_FAR,
  RIGHT_CLOSE,
  LEFT_CLOSE
}
